import { BoxProps, Flex } from '../Box';
import clsx from 'clsx';

export const Tag = (props: BoxProps) => {
  const { cn, className, ...rest } = props;

  return (
    <Flex
      className={clsx('flex items-center rounded-lg px-2 py-1', cn, className)}
      {...rest}
    />
  );
};
